// University of San Diego's undergraduate majors (#2839). Read on 2026-10-01
// from the official 2026-2027 Undergraduate Catalog's Programs list
// (undergraduate.catalog.sandiego.edu/programs, a Coursedog catalog; its
// program search returned 135 undergraduate programs, saved in scratch as
// src-catalog-programs.json). Every program of type "Major" is kept;
// minors, the two major-dependent concentrations, certificates, the four
// teaching credentials and course lists are left out. Names are the
// catalog's display names without the degree suffix; the catalog's college
// codes are written out in full (e.g. "Shiley-Marcos School of Engr" is
// the Shiley-Marcos School of Engineering). The engineering majors carry
// the catalog's combined "Bachelor of Science/Arts" designation, and
// Economics sits in the School of Business, as the catalog files it. The
// "BSN for Registered Nurses" program's catalog name says who it is for;
// the note restates it.
const majors = {
    "slug": "university-of-san-diego",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in USD's official 2026-2027 Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, concentrations, certificates, teaching credentials and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "USD 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://undergraduate.catalog.sandiego.edu/programs"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Architecture",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biophysics",
                    "degree": "B.A."
                },
                {
                    "name": "Biophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Cognition and Behavior",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental & Ocean Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental & Ocean Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Major",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Theology and Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Arts",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Knauss School of Business",
            "source": {
                "label": "USD 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://undergraduate.catalog.sandiego.edu/programs"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "B.Acc."
                },
                {
                    "name": "Business Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Real Estate",
                    "degree": "B.B.A."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.B.A."
                }
            ]
        },
        {
            "name": "Shiley-Marcos School of Engineering",
            "source": {
                "label": "USD 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://undergraduate.catalog.sandiego.edu/programs"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S./B.A."
                },
                {
                    "name": "Engineering",
                    "degree": "B.S./B.A."
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "B.S./B.A."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S./B.A."
                }
            ]
        },
        {
            "name": "School of Leadership and Education Sciences",
            "source": {
                "label": "USD 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://undergraduate.catalog.sandiego.edu/programs"
            },
            "majors": [
                {
                    "name": "Education Studies",
                    "degree": "B.P.S."
                }
            ]
        },
        {
            "name": "Hahn School of Nursing and Health Science",
            "source": {
                "label": "USD 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://undergraduate.catalog.sandiego.edu/programs"
            },
            "majors": [
                {
                    "name": "BSN for Registered Nurses",
                    "degree": "B.S.",
                    "note": "For registered nurses who already hold a nursing license."
                }
            ]
        }
    ]
};

export default majors;
